export type CloudBucketFolderKey = "publicAssets" | "thumbnailAssets";
export type CloudBucketFolders = Record<CloudBucketFolderKey, string>;

export interface FetchGCSassetOptions {
  fetchOptions?: RequestInit;
}

export class GCSAssetFetcher {
  baseUrl: string;
  cloudBucketFolders: CloudBucketFolders;

  constructor(baseUrl: string, cloudBucketFolders: CloudBucketFolders) {
    this.baseUrl = baseUrl;
    this.cloudBucketFolders = cloudBucketFolders;
  }

  constructGCSurl(path: string, cacheKey: string, baseFolder?: CloudBucketFolderKey) {
    const cacheKeyParam = `context=${cacheKey}`;
    let [formattedPath, query] = path.split("?");

    let queryParams;

    if (query) {
      queryParams = `${query}&${cacheKeyParam}`;
    } else {
      queryParams = cacheKeyParam;
    }

    if (formattedPath.startsWith(this.baseUrl)) {
      if (baseFolder) {
        console.error(
          `constructGCSurl - Base folder '${baseFolder}' will be ignored because path start with gcs origin`
        );
      }

      return `${formattedPath}?${queryParams}`;
    }

    if (formattedPath.startsWith("/")) {
      formattedPath = formattedPath.substring(1);
    }

    if (baseFolder && !formattedPath.includes(baseFolder)) {
      // remove any starting slashes in base folder name
      const folderPath = this.cloudBucketFolders[baseFolder].replace("/", "");
      return `${this.baseUrl}/${folderPath}/${formattedPath}?${queryParams}`;
    }

    return `${this.baseUrl}/${formattedPath}?${queryParams}`;
  }

  async fetchAsset(
    baseFolder: CloudBucketFolderKey | undefined,
    path: string,
    cacheKey: string,
    options?: FetchGCSassetOptions
  ) {
    const url = this.constructGCSurl(path, cacheKey, baseFolder);
    return fetch(url, options?.fetchOptions);
  }
}
